export default function ChinhSachGiaoHang() {
  return (
    <div className="bg-white text-gray-800 py-12 px-4 md:px-8 lg:px-16 max-w-6xl mx-auto mt-16">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-pink-600 uppercase">
          Chính Sách Giao Hàng
        </h1>
        <p className="mt-4 text-gray-600 text-base md:text-lg">
          PT2000 cam kết giao hàng nhanh chóng, an toàn và đúng hẹn đến tay khách hàng trên toàn quốc.
        </p>
      </div>

      <div className="space-y-8 text-gray-700 leading-relaxed">
        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">1. Phạm vi giao hàng</h2>
          <p>
            PT2000 thực hiện giao hàng trên toàn quốc, bao gồm tất cả các tỉnh thành từ thành thị đến nông thôn. Đối với các khu vực không nằm trong tuyến giao hàng của đối tác vận chuyển, đơn hàng có thể được điều chỉnh hoặc hủy sau khi thông báo đến khách hàng.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">2. Thời gian giao hàng</h2>
          <ul className="list-disc pl-5">
            <li><strong>TP.HCM:</strong> từ 1 – 2 ngày làm việc</li>
            <li><strong>Các tỉnh miền Nam:</strong> từ 2 – 4 ngày làm việc</li>
            <li><strong>Miền Trung & miền Bắc:</strong> từ 3 – 5 ngày làm việc</li>
            <li>Thời gian giao hàng không tính thứ Bảy, Chủ Nhật & ngày lễ</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">3. Phí giao hàng</h2>
          <ul className="list-disc pl-5">
            <li><strong>Đơn hàng từ 499.000đ trở lên:</strong> Miễn phí giao hàng toàn quốc</li>
            <li><strong>Đơn hàng dưới 499.000đ:</strong> Phí giao hàng 30.000đ – 40.000đ tùy khu vực</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">4. Kiểm tra hàng khi nhận</h2>
          <p>
            Quý khách có quyền kiểm tra bao bì, sản phẩm trước khi thanh toán. Trong trường hợp sản phẩm bị lỗi hoặc không đúng mô tả, vui lòng liên hệ ngay bộ phận hỗ trợ của PT2000 để được xử lý kịp thời.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900">5. Các lưu ý khác</h2>
          <ul className="list-disc pl-5">
            <li>PT2000 không chịu trách nhiệm với các trường hợp giao hàng trễ do thiên tai, dịch bệnh hoặc bên vận chuyển gặp sự cố.</li>
            <li>Thông tin người nhận phải chính xác tuyệt đối để tránh tình trạng thất lạc đơn hàng.</li>
          </ul>
        </div>
      </div>

      <div className="mt-12 text-center border-t pt-6">
        <p className="text-gray-700">
          Nếu có thắc mắc về chính sách giao hàng, vui lòng liên hệ bộ phận hỗ trợ khách hàng qua số điện thoại&nbsp;
          <a href="tel:0784992000" className="text-pink-600 underline font-medium">0784 992 000</a>
        </p>
      </div>
    </div>
  );
}
